export function qualityOpenClose() {
    const openCloseButton = $(".quality-box .open-close-btn");
    let $qualityBox = $(".quality-box .quality-description");
    let $textInner = $(".quality-box .col-text");
    let $nutHolder = $(".col-nuts");
    let almondWidth = 80;

    if ($(window).width() < 1200) {

        for (let i = 0; i < $textInner.length; i++) {
            $nutHolder.css({
                width: $textInner.width() + almondWidth + "px"
            });
        }

        setTimeout(() => {
            for (let j = 0; j < $qualityBox.length; j++) {
                $($qualityBox[j]).css({
                    "max-height": 0
                });
            }
        },500); 
    }

    openCloseButton.on("click", function (e) {
        e.preventDefault();
        const currentParent = $(this).closest(".quality-box");

        $(currentParent).toggleClass("active");
    });
};


// WEBPACK FOOTER //
// ./assets/js/modules/qualityOpenClose.js